/* em-parallax.js — hero Ken-Burns scale parallax
   As the user scrolls through the hero, the video gently zooms in
   (1.0 → 1.12) — a "camera-into-scene" effect that creates depth
   without ever exposing the parent background. Hero text fades out as
   it scrolls toward the next section, reinforcing the transition.
   Honors prefers-reduced-motion. rAF-batched for perf.                  */
(function () {
	'use strict';

	if (
		window.matchMedia &&
		window.matchMedia('(prefers-reduced-motion: reduce)').matches
	) {
		return;
	}

	var media = document.querySelector('.video-banner__media');
	if (!media) return;

	var hero =
		media.closest('.video-banner__content') ||
		media.closest('.video-banner') ||
		media.parentElement;
	if (!hero) return;

	var content = hero.querySelector('.video-banner__wrapper');

	// Tuning knobs
	var SCALE_MAX = 0.12;   // max zoom delta — 0.12 = up to 1.12x
	var FADE_START = 0.35;  // start fading text after 35% of hero scrolled
	var ticking = false;

	function update() {
		ticking = false;

		var rect = hero.getBoundingClientRect();
		var heroHeight = rect.height || window.innerHeight;

		// Bail when hero is far above viewport — leave at final state
		if (rect.bottom < -50) return;

		// Progress: 0 at top of hero in viewport, 1 when hero is fully scrolled past
		// We use -rect.top / heroHeight so progress starts at 0 when hero top is at viewport top
		var progress = Math.max(0, Math.min(1, -rect.top / heroHeight));

		// Scale: grows from 1.0 to (1 + SCALE_MAX)
		var scale = 1 + progress * SCALE_MAX;
		media.style.transform = 'scale(' + scale.toFixed(4) + ')';

		// Content fade + slight upward drift as user scrolls into the next section
		if (content) {
			var fadeProgress = Math.max(
				0,
				(progress - FADE_START) / (1 - FADE_START)
			);
			var opacity = 1 - fadeProgress;
			var translate = fadeProgress * -40; // up to 40px upward drift
			content.style.opacity = opacity.toFixed(3);
			content.style.transform =
				'translate3d(0, ' + translate.toFixed(1) + 'px, 0)';
		}
	}

	function onScroll() {
		if (ticking) return;
		ticking = true;
		requestAnimationFrame(update);
	}

	media.style.willChange = 'transform';
	if (content) content.style.willChange = 'opacity, transform';

	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', onScroll, { passive: true });

	update();
})();
